import swal from "sweetalert2";
import _ from "lodash";
export class BranchingHelper {
  checkOverlap(o1, o2) {
    return !!(Number(o1.startValue) <= Number(o2.endValue) && Number(o1.endValue) >= Number(o2.startValue));
  }

  isUnderRange(startValue, endValue, minValue, maxValue) {
    if (startValue < Number(minValue) && endValue < Number(minValue)) {
      return false;
    } else if (startValue > Number(maxValue) && endValue > Number(maxValue)) {
      return false;
    } else if (startValue < Number(minValue) && endValue > Number(maxValue)) {
      return false;
    }
    return true;
  }

  isUnderMin(startValue, minValue) {
    if (startValue < Number(minValue)) {
      return false;
    }
    return true;
  }

  isUnderMax(endValue, maxValue) {
    if (endValue > Number(maxValue)) {
      return false;
    }
    return true;
  }

  hasProperDecimalPlaces(val, decimalValue) {
    const charCode = val.toString();
    if (charCode.includes(".")) {
      const numb = charCode.split(".")[1];
      if (numb != null && numb.length > decimalValue) {
        return false;
      }
    }
    return true;
  }

  hasDecimal(val) {
    const charCode = val.toString();
    if (charCode.includes(".")) {
      return true;
    }
    return false;
  }

  hasNumberUnderLimit(val, textLimit) {
    const numberCount = this.getNumberCount(val).length;
    if (numberCount > textLimit) {
      return false;
    }
    return true;
  }

  getNumberCount(number) {
    const onlyDigit = Number(String(number).replace(/[^0-9]/g, ""));
    return onlyDigit.toString();
  }

  isConfigurationValidForBranching(addEditQuestion) {
    const stepTypesToValidate = ["Number"];

    if (!addEditQuestion.branchingConfigured || !stepTypesToValidate.includes(addEditQuestion.type)) {
      return true;
    }

    if (addEditQuestion.type == "Number" && addEditQuestion.branchingType && addEditQuestion.branchingType == "advance") {
      return this.isRangeOptionsValid(addEditQuestion);
    }

    return true;
  }

  isRangeOptionsValid(addEditQuestion) {
    const quesBeingEdited = addEditQuestion;
    const branchingOptions = quesBeingEdited.branchingOptions;
    const branchingOptionsLength = quesBeingEdited.branchingOptions.length;
    for (let a = 0; a < branchingOptionsLength; a++) {
      const startValue = Number(branchingOptions[a].startValue);
      const endValue = Number(branchingOptions[a].endValue);

      //-------------------Validation to check decimal and there places when decimals allowed------------------
      if (startValue !== "" && quesBeingEdited.allowDecimals && !this.hasProperDecimalPlaces(startValue, quesBeingEdited.decimalValue)) {
        return false;
      } else if (endValue !== "" && quesBeingEdited.allowDecimals && !this.hasProperDecimalPlaces(endValue, quesBeingEdited.decimalValue)) {
        return false;
      }

      //-------------------Validation to check decimal when decimals not allowed------------------
      if (startValue !== "" && !quesBeingEdited.allowDecimals && this.hasDecimal(startValue)) {
        return false;
      } else if (endValue !== "" && !quesBeingEdited.allowDecimals && this.hasDecimal(endValue)) {
        return false;
      }

      //-------------------Validation to check negative values when not allowed------------------
      if (startValue !== "" && !quesBeingEdited.allowNegative && startValue < 0) {
        return false;
      } else if (endValue !== "" && !quesBeingEdited.allowNegative && endValue < 0) {
        return false;
      }

      //-------------------Validation to check character limit when configured------------------
      if (startValue !== "" && quesBeingEdited.characterLimited && !this.hasNumberUnderLimit(startValue, quesBeingEdited.textLimit)) {
        return false;
      } else if (endValue !== "" && quesBeingEdited.characterLimited && !this.hasNumberUnderLimit(endValue, quesBeingEdited.textLimit)) {
        return false;
      }

      //---------------------Validations to check if the provided values are under min/max range--------
      if (quesBeingEdited.hasMinMax) {
        if (startValue !== "" && endValue !== "") {
          if (!this.isUnderRange(startValue, endValue, quesBeingEdited.minValue, quesBeingEdited.maxValue)) {
            return false;
          } else if (!this.isUnderMin(startValue, quesBeingEdited.minValue)) {
            return false;
          } else if (!this.isUnderMax(endValue, quesBeingEdited.maxValue)) {
            return false;
          }
        }
      }
    }
    return true;
  }

  canConfigureBranching(question, activityQuestions) {
    if (question.branchingConfigured) {
      return true;
    }

    //Validate a step, if it configured in a MC MS recursive branching, If it then do not let branching configured on this step
    //Filter Question thats has recursive branching configured.
    const recursiveBranchingQues = _.filter(activityQuestions, {
      type: "MultiChoice",
      recursiveBranching: true
    });
    if (recursiveBranchingQues.length) {
      const stepsIds = [];
      for (let i = 0; i < recursiveBranchingQues.length; i++) {
        for (let x = 0; x < recursiveBranchingQues[i].options.length; x++) {
          if (recursiveBranchingQues[i].options[x].nextQuestionIdList.includes(question.id)) {
            stepsIds.push(recursiveBranchingQues[i].stepSequence);
          }
        }
      }

      //Not configured a MC MS REC branching, so can cofigure branching.
      if (!stepsIds.length) {
        return true;
      }

      //Cannot Configure branching.
      const stepsString = stepsIds.join(", ").replace(/, ([^,]*)$/, " and $1");
      swal({
        title: `This step is already configured as part of a recursive branching loop on a multiple choice question involving steps ${stepsString}. Defining branching for this question is not allowed.`,
        type: "warning",
        showCancelButton: false,
        confirmButtonColor: "#34537d",
        confirmButtonText: "OK"
      }).then(() => {});

      return false;
    }

    return true;
  }

  optionHasBranchNCanBeRemoved() {
    return new Promise(resolve => {
      swal({
        title: "This step has branching logic defined. Removing this option will remove all branching from this step. Would you like to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f16559",
        cancelButtonColor: "#b8c7ce",
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        reverseButtons: true
      }).then(({ value }) => {
        if (value) {
          //User confirmed Remove Branching
          resolve(true);
        } else {
          //Not confirmed
          //Do not remove option
          resolve(false);
        }
      });
    });
  }

  optionHasBranchConfigured(question, optionBeingDeletedIndex) {
    if (!question.branchingConfigured) {
      return false;
    }

    if (question.type == "MultiChoice") {
      //Check branching only for MC MS NON Recursive
      if (question.multipleSelection && !question.recursiveBranching) {
        //Non Recursive branching
        for (let a = 0; a < question.branchingOptions.length; a++) {
          const branchingOption = _.find(question.branchingOptions[a].optionIds, {
            id: question.options[optionBeingDeletedIndex].id
          });
          if (branchingOption) {
            return true;
          }
        }
      }
    }

    return false;
  }

  removeBranching(addEditQuestion) {
    if (addEditQuestion.type == "Number") {
      addEditQuestion.branchingType = "normal";
      addEditQuestion.branchingOptions = [];
    } else if (addEditQuestion.type == "MultiChoice") {
      if (addEditQuestion.multipleSelection && !addEditQuestion.recursiveBranching) {
        addEditQuestion.branchingOptions = [];
      }
    }

    return addEditQuestion;
  }

  checkIfBranchingRowHasAnyValue(branchingRow) {
    if (branchingRow.nextQuestionIdList && branchingRow.nextQuestionIdList.length) {
      return true;
    } else if (branchingRow.optionIds) {
      if (branchingRow.optionIds.length || this.checkIfNextQuestionHasValue(branchingRow.nextQuestionId)) {
        return true;
      }
    } else if (branchingRow.startValue && branchingRow.endValue) {
      if (branchingRow.startValue !== "" || branchingRow.endValue !== "" || this.checkIfNextQuestionHasValue(branchingRow.nextQuestionId)) {
        return true;
      }
    }

    return false;
  }

  disableTrashCan(branchingRow) {
    return !this.checkIfBranchingRowHasAnyValue(branchingRow);
  }

  checkIfNextQuestionHasValue(nextQuestionId) {
    return nextQuestionId != "default" && nextQuestionId != "" && nextQuestionId != null;
  }

  checkIfNextQuestionIsEmpty(nextQuestionId) {
    return nextQuestionId == "default" || nextQuestionId == "" || nextQuestionId == null;
  }
}
